export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-10 mb-10 md:mb-12">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-bold text-sm">91</span>
              <span className="font-heading font-bold text-lg text-background-50 whitespace-nowrap">91电影视频</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              免费高清影视在线观看平台，海量电影、电视剧、综艺、动漫即点即播，每日更新最新剧集，无需注册畅享1080P超清画质。
            </p>
          </div>

          <div>
            <h3 className="font-semibold text-sm text-background-50 mb-3 md:mb-4">快速导航</h3>
            <nav className="flex flex-col gap-2">
              <a href="#hero" className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap cursor-pointer">首页</a>
              <a href="#topics" className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap cursor-pointer">热门分类</a>
              <a href="#ranking" className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap cursor-pointer">热门排行</a>
              <a href="#faq" className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap cursor-pointer">常见问题</a>
            </nav>
          </div>

          <div>
            <h3 className="font-semibold text-sm text-background-50 mb-3 md:mb-4">合作伙伴</h3>
            <p className="text-sm text-background-400 leading-relaxed">
              诚邀优质内容方和品牌方合作，共同打造更好的观影体验。
            </p>
          </div>

          <div>
            <h3 className="font-semibold text-sm text-background-50 mb-3 md:mb-4">关注我们</h3>
            <div className="flex gap-3">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:text-background-50 hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-base"></i>
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:text-background-50 hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-base"></i>
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:text-background-50 hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-bilibili-line text-base"></i>
              </span>
            </div>
          </div>
        </div>

        <div className="pt-6 md:pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500 whitespace-nowrap">© 2026 91电影视频. 本站所有内容仅供学习和交流使用。</p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer whitespace-nowrap">隐私政策</span>
            <span className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer whitespace-nowrap">使用条款</span>
          </div>
        </div>
      </div>
    </footer>
  );
}